export const MAIN_TEXT_COLOR = '#F5F5F5';
export const SECOND_TEXT_COLOR = '#000000';
export const THIRD_TEXT_COLOR = '#726D6D';
export const FOURTH_TEXT_COLOR = '#B0AAB0';
export const BUTTON_SEE_MORE_TEXT_COLOR = '#337CD1';

export const MAIN_SITE_COLOR = '#35476B';
export const MAIN_BACKGROUND_COLOR =
  'linear-gradient(180deg, rgba(221, 230, 250, 0.8) 0%, rgba(255, 255, 255, 0) 100%), #F2F2F2;';
export const PROJECT_BACKGROUND_COLOR = '#C4C4C4';
